import React from 'react';
import { useAuth } from '../../../../../../utils/Auth';
import styles from './ThankYouCard.module.css';

export default function ThankYouCard() {

    const { qr_data, dataDispatch } = useAuth();
    
    const handleTitle = e => {
        dataDispatch({type: 'survey', data: { post_survey_options: { ...qr_data?.data?.survey?.post_survey_options, title: e.target.value }}});
    };

    const handleMessage = e => {
        dataDispatch({type: 'survey', data: { post_survey_options: { ...qr_data?.data?.survey?.post_survey_options, message: e.target.value }}});
    };

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <input id='post-survey-title' type='text' className={styles.inputTitle} maxLength='50' defaultValue={qr_data?.data?.survey?.post_survey_options?.title} placeholder='Edit Title Here' onChange={handleTitle} />
            </div>
            <div className={styles.body}>
                <div className={styles.envelopeWrap}>
                    <i className={`fas fa-check ${styles.checkIcon}`} />
                    <i className={`fa-duotone fas fa-hands-holding-diamond ${styles.handsIcon}`} />
                </div>
                <textarea id='post-survey-message' type='text' className={styles.inputMessage} maxLength='100' defaultValue={qr_data?.data?.survey?.post_survey_options?.message} placeholder='Edit Message Here' onChange={handleMessage} />
            </div>
        </div>
    );
};